import React, { FC, memo, useState, useEffect } from 'react'
import ImagePlaceholderIcon from '../icons/image-placeholder.svg'

interface IProductPhotoProps {
  photo?: string | null
  className?: string
}

const ProductPhoto: FC<IProductPhotoProps> = ({ photo, className }) => {
  const [showPlaceholder, setShowPlaceholder] = useState(!photo)

  useEffect(() => {
    setShowPlaceholder(!photo)
  }, [photo])

  if (showPlaceholder) {
    return <ImagePlaceholderIcon className={className} />
  }

  return (
    <img
      src={photo}
      className={className}
      alt=""
      onError={() => setShowPlaceholder(true)}
    />
  )
}

export default memo(ProductPhoto)
